import './BottomSheetHandle.css';

const BottomSheetHandle = () => <div className='bottom-sheet-handle' aria-hidden='true' />;

export default BottomSheetHandle;
